import { Link } from "@tanstack/react-router";
import { CATEGORIES } from "../content/categories";

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-rule bg-paper mt-24">
      <div className="mx-auto max-w-6xl px-5 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div
            className="text-2xl font-semibold tracking-tight"
            style={{ fontFamily: "var(--font-display)" }}
          >
            Acadly<span className="text-grade">.</span>in
          </div>
          <p className="mt-3 max-w-md text-sm text-pencil leading-relaxed">
            Study notes, exam strategy and honest college guidance for Indian
            undergraduates. Written by someone who actually sat the exams.
          </p>
          <div className="mt-5 stamp">Est. 2026 · New Delhi</div>
        </div>

        <div>
          <div className="mono-label mb-3">Sections</div>
          <ul className="space-y-1.5 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to="/category/$category"
                  params={{ category: c.slug }}
                  className="hover:text-grade transition-colors"
                >
                  {c.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/blog" className="hover:text-grade transition-colors">
                All posts
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="mono-label mb-3">Site</div>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/about" className="hover:text-grade transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-grade transition-colors">Contact</Link></li>
            <li><Link to="/editorial-policy" className="hover:text-grade transition-colors">Editorial Policy</Link></li>
            <li><Link to="/corrections" className="hover:text-grade transition-colors">Corrections</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-grade transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-grade transition-colors">Terms</Link></li>
            <li><Link to="/disclaimer" className="hover:text-grade transition-colors">Disclaimer</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-rule">
        <div className="mx-auto max-w-6xl px-5 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-pencil">
          <div>© {year} Acadly.in — All rights reserved.</div>
          <div className="mono-label">Made in India · Reader-supported</div>
        </div>
      </div>
    </footer>
  );
}